import { TypeStrategy } from "@/@types/strategies/modalStrategy"
import { ActionPlanStrategy } from "../utils/enums"

export enum ChannelType {
  WhatsApp = 'WhatsApp',
  Email = 'Email',
  Messenger = 'Messenger',
  Webchat = 'Webchat',
  Telefonia = 'Telefonia',
  Sms = 'Sms',
  Instagram = 'Instagram',
}

export enum PlanPayType {
  Prepaid = 1,
  Postpaid = 2,
}

export const PlanPayTypeText: { [key: number]: string } = {
  [PlanPayType.Prepaid]: 'Prepago',
  [PlanPayType.Postpaid]: 'Postpago',
}

export const PlanPayTypeColor: { [key: number]: string } = {
  [PlanPayType.Prepaid]: 'blue',
  [PlanPayType.Postpaid]: 'pink',
}

export const PlanPayTypeDescription: { [key: number]: string } = {
  [PlanPayType.Prepaid]: 'El cliente pagará mensualmente el costo de su plan.',
  [PlanPayType.Postpaid]: 'El equipo de ventas se contactará con el cliente para coordinar el pago.',
}

export const ConsumePayTypeDescription: { [key: number]: string } = {
  [PlanPayType.Prepaid]: 'El cliente recargará su wallet según los consumos que desea realizar por canal. Se les regalará $2 de recarga en cada canal de su plan 🎁.',
  [PlanPayType.Postpaid]: 'El cliente tendrá consumos ilimitados. El equipo de ventas se contactará con el cliente para coordinar el pago del monto total.',
}

export enum PlanType {
  Digital = 1,
  Voice = 2,
  DigitalVoice = 3,
  AllInOne = 4,
}

export const PlanEspecial = 5;

export const PlanTypeText: Record<PlanType, string> = {
  [PlanType.Digital]: 'Digital',
  [PlanType.Voice]: 'Voice',
  [PlanType.DigitalVoice]: 'Digital + Voice',
  [PlanType.AllInOne]: 'All in one',
}

export const ChannelTypeAttribute = {
  [ChannelType.WhatsApp]: "whatsapp",
  [ChannelType.Email]: "email",
  [ChannelType.Messenger]: "facebook",
  [ChannelType.Webchat]: "webchat",
  [ChannelType.Telefonia]: "voz",
  [ChannelType.Sms]: "sms",
  [ChannelType.Instagram]: "instagram",
};

export const PlanTypeIcon: Record<PlanType, string> = {
  [PlanType.Digital]: "digital.png",
  [PlanType.Voice]: "voice.png",
  [PlanType.DigitalVoice]: "digital+voice.png",
  [PlanType.AllInOne]: "all-in-one.png",
};

export interface IPlan {
  id?: number;
  name: string;
  configuration: any;
}

export interface ICustomerPlan {
  id: number;
  reference_name: string,
  plan: number;
  contract_duration_month: number;
  activation_fee: string;
  contract_expired_at: string;
  state: number;
  url_invitation: string;
  link_vality_date: string;
  destination_email: string;
  url_landing_page: string;
  type_plan_license: number;
  type_plan_consume: number;
  customer: string;
  user_modify: any;
  last_change_status_date: Date;
  reason_for_deactivation: string;
  valid_link_date: Date;
}

export enum ClientStatus {
  Pending = 1,
  Expired = 2,
  Actived = 3,
  Renewer = 4,
  Inactived = 5,
  Suspended = 6,
  Refused = 7,
  Deleted = 8,
  Canceled = 9,
};

export const ClientStatusText: Record<ClientStatus, string> = {
  [ClientStatus.Pending]: "Registro pendiente",
  [ClientStatus.Expired]: "Enlace caducado",
  [ClientStatus.Actived]: "Activo",
  [ClientStatus.Renewer]: "Actualización",
  [ClientStatus.Inactived]: "Inactivo",
  [ClientStatus.Suspended]: "Enlace cancelado",
  [ClientStatus.Refused]: "Rechazado",
  [ClientStatus.Deleted]: "Eliminado",
  [ClientStatus.Canceled]: "Cancelado",
};

export const ClientStatusColor: Record<ClientStatus, string> = {
  [ClientStatus.Pending]: "warning",
  [ClientStatus.Expired]: "default",
  [ClientStatus.Actived]: "success",
  [ClientStatus.Renewer]: "gold",
  [ClientStatus.Inactived]: "default",
  [ClientStatus.Suspended]: "default",
  [ClientStatus.Refused]: "orange",
  [ClientStatus.Deleted]: "red",
  [ClientStatus.Canceled]: "default",
};

export enum ReasonInactivate {
  NotPayPlan = 1,
  NotRenewContract = 2,
  Others = 3,
}

export const ReasonInactivateText: Record<ReasonInactivate, string> = {
  [ReasonInactivate.NotPayPlan]: "El cliente no pagó su plan",
  [ReasonInactivate.NotRenewContract]: "El cliente no renovó su contrato",
  [ReasonInactivate.Others]: "Otros",
};

export enum PlanAction {
  Edit = 'edit',
  Downgrade = 'downgrade',
  Upgrade = 'upgrade',
  EditionActive = 'edition-active',
}
export const PlanActionText: Record<PlanAction, string> = {
  [PlanAction.Edit]: 'editar',
  [PlanAction.Upgrade]: 'upgrade',
  [PlanAction.Downgrade]: 'downgrade',
  [PlanAction.EditionActive]: 'la edición',
}

export const PlanActionTextUpper: Record<PlanAction, string> = {
  [PlanAction.Edit]: 'Editar',
  [PlanAction.Upgrade]: 'Upgrade',
  [PlanAction.Downgrade]: 'Downgrade',
  [PlanAction.EditionActive]: 'Edición',
}

export const PlanActionTitle: Record<PlanAction, string> = {
  [PlanAction.Edit]: '',
  [PlanAction.Upgrade]: 'Upgrade plan',
  [PlanAction.Downgrade]: 'Downgrade plan',
  [PlanAction.EditionActive]: 'Edición de plan',
}

export const PlanActionDescription: Record<PlanAction, string> = {
  [PlanAction.Edit]: '',
  [PlanAction.Upgrade]: `Compara tu plan actual con el upgrade antes de tomar una decisión. Si apruebas el upgrade, te contactaremos para <br/>
    programarlo y configures tu ambiente según las nuevas consideraciones. Si prefieres mantener tu plan, cancela el upgrade.  `,
  [PlanAction.Downgrade]: `Compara tu plan actual con el downgrade antes de tomar una decisión. Si apruebas el downgrade, te contactaremos para
    programarlo y configures tu ambiente según las nuevas consideraciones. Si prefieres mantener tu plan, cancela el downgrade.  `,
  [PlanAction.EditionActive]: `Compara tu plan actual con el editado antes de tomar una decisión. Si apruebas la edición, te contactaremos para programarlo
    y configures tu ambiente, de ser necesario. Si prefieres mantener tu plan, cancela la edición.`,
}

export const PlanActionDetails: Record<PlanAction, string> = {
  [PlanAction.Edit]: 'Detalles del plan',
  [PlanAction.Downgrade]: 'Detalles del downgrade',
  [PlanAction.Upgrade]: 'Detalles del upgrade',
  [PlanAction.EditionActive]: 'Editar plan',
}

export enum PlanActionValue {
  Upgrade = 1,
  Downgrade = 2,
  EditionActive = 3,
}

export const PlanActionName: Record<PlanActionValue, string> = {
  [PlanActionValue.Upgrade]: 'upgrade',
  [PlanActionValue.Downgrade]: 'downgrade',
  [PlanActionValue.EditionActive]: 'editado',
}

export const PlanActionNamePresent: Record<PlanActionValue, string> = {
  [PlanActionValue.Upgrade]: 'upgrade',
  [PlanActionValue.Downgrade]: 'downgrade',
  [PlanActionValue.EditionActive]: 'edición',
}

export enum ChannelPlanType {
  WhatsApp = 1,
  Webchat = 2,
  Messenger = 3,
  Sms = 4,
  Telefonia = 5,
  Instagram = 6,
  Email = 7,
}

export const ChannelPlan: Record<ChannelPlanType, string> = {
  [ChannelPlanType.WhatsApp]: 'whatsapp',
  [ChannelPlanType.Webchat]: 'webchat',
  [ChannelPlanType.Messenger]: 'facebook',
  [ChannelPlanType.Sms]: 'sms',
  [ChannelPlanType.Telefonia]: 'voz',
  [ChannelPlanType.Instagram]: 'instagram',
  [ChannelPlanType.Email]: 'email',
}

export enum UpgradeDowngradeState {
  Approved = 1,
  Reject = 2,
  Pending = 3,
  Expired = 4,
  Programmed = 5,
}


export const PlanTypeStrategy: Record<PlanType, Record<TypeStrategy, number | null>> = {
  [PlanType.Digital]: {
    [TypeStrategy.Predictive]: ActionPlanStrategy.Upgrade,
    [TypeStrategy.Progressive]: ActionPlanStrategy.Upgrade,
    [TypeStrategy.Sms]: null,
    [TypeStrategy.Ivr]: ActionPlanStrategy.Upgrade,
    [TypeStrategy.Whatsapp]: null,
    [TypeStrategy.Email]: null,
  },
  [PlanType.Voice]: {
    [TypeStrategy.Predictive]: ActionPlanStrategy.Personalized,
    [TypeStrategy.Progressive]: null,
    [TypeStrategy.Sms]: ActionPlanStrategy.Upgrade,
    [TypeStrategy.Ivr]: ActionPlanStrategy.Personalized,
    [TypeStrategy.Whatsapp]: ActionPlanStrategy.Upgrade,
    [TypeStrategy.Email]: ActionPlanStrategy.Upgrade,
  },
  [PlanType.DigitalVoice]: {
    [TypeStrategy.Predictive]: ActionPlanStrategy.Personalized,
    [TypeStrategy.Progressive]: null,
    [TypeStrategy.Sms]: null,
    [TypeStrategy.Ivr]: ActionPlanStrategy.Personalized,
    [TypeStrategy.Whatsapp]: null,
    [TypeStrategy.Email]: null,
  },
  [PlanType.AllInOne]: {
    [TypeStrategy.Predictive]: null,
    [TypeStrategy.Progressive]: null,
    [TypeStrategy.Sms]: null,
    [TypeStrategy.Ivr]: null,
    [TypeStrategy.Whatsapp]: null,
    [TypeStrategy.Email]: null,
  },
}